<template>
  <div class="home-box">
    <v-layout row v-if="errors" class="py-5">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col cols="12" lg="4" md="4" offset-md="4" offset-lg="4" sm="12">       
        <v-progress-linear v-if="loading" indeterminate color="blue"></v-progress-linear>
        <v-card class="pa-1">
          <v-avatar color="blue" size="50" class="ma-3 mb-0">
              <v-icon color="white" >mdi-account-question</v-icon>
            </v-avatar>
          <v-card-title dark class="ma-3">
            <h6 class="text-h6 font-weight-medium">Please Select a Role</h6>
          </v-card-title>
          <v-card-text>
      <v-form>
        <v-select v-model="selectedRole" :items="roles_with_permissions" label="Role*" item-text="role.name" item-value="role.id" dense outlined></v-select>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-btn dark color="blue" block @click="setRole" :loading="loading" depressed>Next</v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Navbar :MenuItems="MenuList" />
  <Snackbars :text="successMsg" :snackbar="snackbar" :color="'warning'" @classSnackbar="closeSnackbar" />
  </div>
</template>

<script>
import Navbar from "@/components/shared/Navbar";
import { mapGetters } from "vuex";
import { AuthService } from "../../services/auth-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import Alert from "@/components/shared/Alert";

export default {
  name: "SwithRole",
  components: { Navbar, Snackbars, Alert },
  data() {
    return {
      form: {
        otp: ""
      },
      roles: [],
      otpForm: true,
      MenuList: [],
      roles_with_permissions: [],
      selectedRole: null,
      errors: null,
      roleLength: null,
      role: localStorage.getItem("role"),
      logo: require("@/assets/logo.png"),
      loading: false,
      snackbar: false,
      successMsg: " ",
    };
  },
  mounted() {
    this.getUserRoles();
    this.getMenuList();
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },
  computed: {
    ...mapGetters("auth", {
      profile: "profile",
    }),
  },
  watch: {
    selectedRole(newRole, oldRole) {
      if (newRole !== oldRole) {
        this.getMenuList();
      }
    },
   '$route.query.id': {
      handler(id) {
        this.dialog = true; 
        if (id) { 
          this.errors = ['You do not have the necessary permissions. Please contact your administrator.'];
        }
      },
      immediate: true
    },
  },
  methods: {
    setRole() {
      this.$store
        .dispatch("auth/menuSet", {
          MenuList: this.MenuList,
        });
      if (this.selectedRole) {
        const selectedRoleData = this.roles_with_permissions.find(roleData => roleData.role.id === this.selectedRole);
        this.$store.dispatch("auth/roleSet", selectedRoleData).then((response) => {
          if (response === selectedRoleData) {
            this.$router.push("/");
            this.dialog = false; 
          }
        });
      }
    },
    getMenuList() {
      this.onDismissed();
      if (this.selectedRole) {
        this.loading = true;
        AuthService.getMenuList(this.selectedRole)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.MenuList = response.data;
              if (this.roleLength === 1) {
                this.setRole();
              }
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MenuList = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    getUserRoles() {
      this.onDismissed();
      AuthService.getUserRoles()
        .then((response) => {
          this.loading = false;
          if (response.data.role_with_permissions) {
            this.roles_with_permissions = response.data.role_with_permissions;
            this.roleLength = response.data.data.length;
            this.selectedRole = response.data.data[0].id;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.roles_with_permissions = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    onDismissed() {
      this.errors = null;
    },
  },
};
</script>